// Libraries
var React = require('react');
var ReactDOM = require('react-dom');

// Components
var CallToAction = require('CallToAction/CallToAction');

// Styles
require('./PromptModule.scss');

class PromptModule extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			visible: true,
		}
	}

	unmountSelf = _ => {
		if (this.props.popUpHandler) {
			this.props.popUpHandler();
		}
		ReactDOM.unmountComponentAtNode(document.getElementById('SpursPrompt'));
	};

	handleClick = _ => {
		this.unmountSelf();
		this.props.callback();
	};

	handleEsc = e => {
		if (e.key === 'Escape') {
			this.unmountSelf();
		}
	}

	componentDidMount() {
		this.dialog.focus();
	}

	render() {
		return (
			<React.Fragment>
				<div className={"Prompt" + (this.state.visible ? " Prompt--show" : "")} onClick={this.unmountSelf}>
				</div>
				<div className="Prompt__dialog" ref={dialog => this.dialog = dialog} tabIndex="0" onKeyDown={this.handleEsc}>
					<div className="header rte">
						<h2>{this.props.promptTitle}</h2>
						<p>{this.props.promptText}</p>
					</div>
					<div className="options">
						<button onClick={this.unmountSelf} className="cta cta--secondary" type="button">Cancel</button>
						{this.props.link &&
								<div className="confirm cta">
									<CallToAction {...this.props.link} button />
								</div>
						}
						{this.props.callback && !this.props.link &&
								<div className="confirm cta" onClick={this.handleClick}>
									<CallToAction linkStyle="primary" button="true" caption={this.props.caption} />
								</div>
						}
					</div>
				</div>
			</React.Fragment>
		);
	}
}

module.exports = PromptModule;



// WEBPACK FOOTER //
// ./src/components/PromptModule/PromptModule.js